<template>
  <div>
<!--    <el-button type="primary" @click="visible = true">开通账号</el-button>-->
    <el-dialog
      :visible.sync="visible_new"
      width="680px"
      custom-class="modal_custom"
      @close ="$emit('mlogin_clean')"
    >
      <div class="modal_content">
        <div class="modal_content_text1">登录后可查看更多案例</div>
        <div class="modal_content_text2">若您没有账号，可以扫码添加企业微信联系客服为您开通账号</div>
        <img class="modal_content_qr_code" alt="二维码" :src="require('@/assets/img/qrcode.png')"/>
        <div class="modal_content_btn">
<!--          <el-button class="modal_content_btn_submit" type="primary">登录</el-button>-->
          <el-button class="modal_content_btn_cancel" type="primary" plain @click ="$emit('mlogin_clean')" style="margin-left: unset">返回</el-button>
        </div>
      </div>
    </el-dialog>
<!--    <el-button type="primary" @click="visible2 = true">扫码注册</el-button>-->
    <el-dialog
      :visible.sync="visible2_new"
      width="680px"
      custom-class="modal_custom"
      @close ="$emit('mlogin_clean')"
    >
      <div class="modal_content">
        <div class="modal_content_text1">您可以扫码添加企业微信联系客服注册账号</div>
        <img class="modal_content_qr_code" alt="二维码" :src="require('@/assets/img/qrcode.png')"/>
        <div class="modal_content_btn">
<!--          <el-button class="modal_content_btn_submit" type="primary">登录</el-button>-->
          <el-button class="modal_content_btn_cancel" type="primary" plain @click ="$emit('mlogin_clean')" style="margin-left: unset">返回</el-button>
        </div>
      </div>
    </el-dialog>
<!--    <el-button type="primary" @click="visible3 = true">提交需求</el-button>-->
    <el-dialog
      :visible.sync="visible3_new"
      width="680px"
      custom-class="modal_custom"
      @close ="$emit('mlogin_clean')"
    >
      <div class="modal_content">
        <div class="modal_content_text1">我们已收到您的需求，稍后会有负责人与您联系，请耐心等待</div>
        <div class="modal_content_text2">您可以扫描二维码添加我们的企业微信</div>
        <img class="modal_content_qr_code"  alt="二维码" :src="require('@/assets/img/qrcode.png')"/>
        <div class="modal_content_btn">
          <el-button class="modal_content_btn_submit" type="primary" @click ="$emit('mlogin_clean')">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: 'Common',
  props: ['visible','visible2','visible3'],
  data() {
    return {
      visible_new:false,
      visible2_new:false,
      visible3_new:false
    }
  },
  mounted() {
    this.visible_new = this.visible
    this.visible2_new = this.visible2
    this.visible3_new = this.visible3
  },
  watch: {
    visible: {
      handler(newval,oldval){
         this.visible_new = newval
      },
      deep: true,
      immediate: true
    },
    visible2: {
      handler(newval,oldval){
        this.visible2_new = newval
      },
      deep: true,
      immediate: true
    },
    visible3: {
      handler(newval,oldval){
        this.visible3_new = newval
      },
      deep: true,
      immediate: true
    },
  }

}
</script>




// WEBPACK FOOTER //
// src/components/Common.vue